export default {
  "content": "<title>Icon Copy 4</title><g transform=\"translate(7 2)\" stroke=\"#4F268C\" stroke-width=\"2\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"27\" cy=\"27\" r=\"27\"/><path d=\"M27 35c-7.953 0-15.077 3.682-20 9.5 4.923 5.818 12.047 9.5 20 9.5 7.953 0 15.077-3.682 20-9.5-4.923-5.818-12.047-9.5-20-9.5zM27 6v2M12 12l1.414 1.414M6 27h2M49 27h-2M42.414 12L41 13.414M27 35l19-16\"/></g>",
  "attrs": {
    "width": "68",
    "height": "58",
    "viewBox": "0 0 68 58",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};